import React from 'react';
import { Button } from './Button';
import { Star, FileText, Users, ThumbsUp } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-28 pb-12 px-4 bg-gradient-to-b from-navy-900 to-navy-800 overflow-hidden" data-id="element-59">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-60" />

      <div className="max-w-4xl mx-auto text-center relative z-10 space-y-6" data-id="element-61">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-500/10 border border-gold-500/30 text-gold-400 font-semibold text-sm" data-id="element-62">
          <Star className="w-4 h-4 fill-gold-400" data-id="element-63" />
          <span data-id="element-64">Il sistema completo per insegnanti di inglese</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-white" data-id="element-65">
          MegaPack Inglese™ <br data-id="element-66" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-67">
            Lezioni coinvolgenti in pochi minuti.
          </span>
        </h1>

        <div className="relative max-w-xl mx-auto" data-id="element-68">
          <a href="#offer" className="block" data-id="element-69">
            <div className="rounded-2xl overflow-hidden shadow-2xl shadow-gold-500/20 border border-gold-500/20" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/vvgYKpfnqUorGXLQbTptDN/ChatGPT_Image_Mar_27,_2026,_06_56_22_PM.png" alt="MegaPack Inglese Bundle" className="w-full h-auto object-cover" data-id="element-71" />
            </div>
            <div className="absolute -bottom-3 -right-3 bg-brand-red text-white font-bold py-2 px-4 rounded-full shadow-xl transform rotate-[-5deg] border-4 border-navy-900 animate-pulse text-sm" data-id="element-72">
              🔥 Offerta Limitata
            </div>
          </a>
        </div>

        <div className="bg-navy-700/50 border border-navy-600 rounded-xl py-3 px-6 inline-block" data-id="element-73">
          <p className="text-lg font-bold text-white" data-id="element-74">
            <span className="text-gold-400 text-xl" data-id="element-75">5</span> Libri +{' '}
            <span className="text-brand-green text-xl" data-id="element-76">6</span> Bonus Gratuiti
          </p>
        </div>

        <div data-id="element-77">
          <Button href="#offer" className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-78">
            Voglio il mio MegaPack Inglese adesso!
          </Button>
        </div>

        {/* Social proof stats integrated */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-4 border-t border-navy-700 mt-6" data-id="element-79">
          {[{
          icon: FileText,
          text: '300+ Risorse'
        }, {
          icon: Users,
          text: '500+ Insegnanti'
        }, {
          icon: Star,
          text: '4.9/5 Media'
        }, {
          icon: ThumbsUp,
          text: '100% Soddisfatti'
        }].map((stat, i) => <div key={i} className="flex flex-col items-center gap-1.5 text-gray-400 text-xs" data-id="element-80">
              <stat.icon className="w-5 h-5 text-gold-400" data-id="element-81" />
              <span className="font-semibold" data-id="element-82">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </section>;
}